import { FaBook, FaUsers, FaAward } from 'react-icons/fa'
import { FaArrowRightLong } from "react-icons/fa6";
import { BiSolidOffer } from "react-icons/bi";
import { Link } from 'react-router-dom'
import EnquiryForm from './EnquiryForm'
import { IoLibrarySharp } from "react-icons/io5";
import { FaBuilding } from "react-icons/fa";
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
export default function HeroSection() {
    const handleWhatsAppClick = () => {
        const message = encodeURIComponent("Hi, Can I know more about SSS Achievers?");
        const phoneNumber = "+919918519991";
        const url = `https://wa.me/${phoneNumber}?text=${message}`;
        window.open(url, "_blank");
    };
    return (
        <section className="relative sm:min-h-[calc(100vh-100px)] bg-gradient-to-b from-blue-50 to-white">
            {/* Admissions Open flicker banner */}
            <div className="bg-[#0097b2] text-white text-center py-2 px-4">
                <span className="inline-flex items-center gap-2 text-sm font-semibold">
                    <span className="relative flex h-2.5 w-2.5">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#fcbf0a] opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#fcbf0a]"></span>
                    </span>
                    <span>
                        Admissions Open 2026 &mdash; Limited Seats Available!&nbsp;
                        <a
                            href="https://wa.me/919918519991?text=Hello%20SSS%20Achievers%2C%20I%20want%20to%20enroll%20for%202026%20batch."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline underline-offset-2 font-bold hover:text-[#fcbf0a] transition-colors"
                        >
                            Enroll Now &rarr;
                        </a>
                    </span>
                </span>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16 lg:py-20">
                <div className="flex justify-between items-center flex-col lg:flex-row">
                    <div className="hero-content">
                        <h1 className="hero-headline tracking-tight font-bold text-gray-900 text-3xl sm:text-4xl md:text-4xl">
                            <span className="block xl:inline">Your pathway to</span>{' '}
                            <span className="block primary-color-front xl:inline">academic excellence!</span>
                        </h1>
                        <p className="mt-3 text-sm text-gray-500 sm:mt-5 sm:text-base sm:max-w-xl sm:mx-auto md:mt-5 md:text-lg lg:mx-0">
                            SSS Achievers is Ghazipur’s leading coaching institute for students of 8th to 12th standard, providing expert guidance and personalized support for strong foundations and academic excellence.
                        </p>
                        <div className="mt-8 sm:max-w-lg sm:mx-auto sm:text-center lg:text-left lg:mx-0">
                            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                                <Link
                                    onClick={handleWhatsAppClick}
                                    className="primary-color inline-flex items-center feature-box justify-center px-5 py-3 border border-transparent text-sm font-medium rounded text-white hover:bg-[#007a8f] main-hero-button"
                                >
                                    Free Consultation
                                    <FaArrowRightLong className="ml-2 -mr-1 h-5 w-5" aria-hidden="true" />
                                </Link>
                                <Link
                                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                    to="/courses"
                                    className="inline-flex items-center feature-box justify-center px-5 py-3 border border-[#0097b2] text-sm font-medium rounded text-[#0097b2] bg-white hover:bg-blue-50"
                                >
                                    Explore Courses
                                </Link>
                            </div>
                        </div>
                        <div className="flex flex-col items-start mb-2 lg:mb-0 gap-4 mt-6 sm:flex-row sm:items-center sm:gap-4">

                            <AvatarGroup
                                total={470}
                                sx={{
                                    '& .MuiAvatar-root': {
                                        width: 48,
                                        height: 48,
                                        border: '3px solid #fff',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.10)',
                                        fontWeight: 600,
                                        fontSize: 18,
                                        background: '#ddd',
                                        color: '#000',
                                        transition: 'transform 0.2s',
                                        '&:hover': {
                                            transform: 'scale(1.08)',
                                            boxShadow: '0 8px 24px rgba(59,130,246,0.15)',
                                        },
                                    },
                                }}
                            >
                                <Avatar alt="Rahul" src="https://mui.com/static/images/avatar/5.jpg" />
                                <Avatar alt="Travis Howard" src="./images/avatar2.png" />
                                <Avatar alt="Agnes Walker" src="./images/avatar3.png" />
                                <Avatar alt="Trevor Henderson" src="./images/avatar4.png" />
                            </AvatarGroup>
                            <span className="text-sm font-semibold text-gray-700 bg-white/80 px-3 py-1 rounded-full shadow-sm border border-blue-100">
                                Trusted by <span className="text-[#0097b2] font-semibold">450+</span> Students
                            </span>
                        </div>
                    </div>
                    <div className='flex justify-end'>
                        <EnquiryForm />
                    </div>
                </div>
                <div className="mt-16 sm:mt-24">
                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:flex lg:justify-center lg:content-center lg:items-center gap-4">
                        <div className="flex flex-col items-center feature-box p-4 bg-white rounded-lg shadow-md sm:shadow-none sm:bg-transparent sm:rounded-none">
                            <FaBook className="h-8 w-8 mb-2" style={{ color: "#00b7c3" }} />
                            <span className="text-sm font-medium text-gray-900">Top-ranked study materials</span>
                        </div>
                        <div className="flex flex-col items-center feature-box p-4 bg-white rounded-lg shadow-md sm:shadow-none sm:bg-transparent sm:rounded-none">
                            <FaUsers className="h-8 w-8 mb-2" style={{ color: "#00b7c3" }} />
                            <span className="text-sm font-medium text-gray-900">Experienced faculty</span>
                        </div>
                        <div className="flex flex-col items-center feature-box p-4 bg-white rounded-lg shadow-md sm:shadow-none sm:bg-transparent sm:rounded-none">
                            <FaAward className="h-8 w-8 mb-2" style={{ color: "#00b7c3" }} />
                            <span className="text-sm font-medium text-gray-900">Proven track record</span>
                        </div>
                        <div className="flex flex-col items-center feature-box p-4 bg-white rounded-lg shadow-md sm:shadow-none sm:bg-transparent sm:rounded-none">
                            <BiSolidOffer className="h-8 w-8 mb-2" style={{ color: "#00b7c3" }} />
                            <span className="text-sm font-medium text-gray-900">Affordable Fees</span>
                        </div>
                        <div className="flex flex-col items-center feature-box p-4 bg-white rounded-lg shadow-md sm:shadow-none sm:bg-transparent sm:rounded-none">
                            <IoLibrarySharp className="h-8 w-8 mb-2" style={{ color: "#00b7c3" }} />
                            <span className="text-sm font-medium text-gray-900">Library Access</span>
                        </div>
                        <div className="flex flex-col items-center feature-box p-4 bg-white rounded-lg shadow-md sm:shadow-none sm:bg-transparent sm:rounded-none">
                            <FaBuilding className="h-8 w-8 mb-2" style={{ color: "#00b7c3" }} />
                            <span className="text-sm font-medium text-gray-900">Modern Infrastructure</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

